import Button from '@/storybook/components/Button/Button';
import Link from '@/storybook/components/Link/Link';
import Switch from '@/storybook/components/Switch/Switch';
import { FC, PropsWithChildren } from 'react';
import styles from './DropdownActionBar.module.css';

export type DropdownActionBarProps = {
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  label: string;
} & (
  | {
      type: 'switch';
      value: boolean;
      href?: string;
      onClick: () => void;
    }
  | {
      type: 'button' | 'textButton';
      value?: boolean;
      href?: string;
      onClick: () => void;
    }
  | {
      type: 'link';
      value?: boolean;
      href: string;
      onClick?: () => void;
    }
);

const DropdownActionBarWrapper: FC<PropsWithChildren<Pick<DropdownActionBarProps, 'type'>>> = ({ type, children }) => (
  <div className={styles.dropdownActionBar} data-type={type} data-testid="dropdownActionBar">
    {children}
  </div>
);

const DropdownActionBar: FC<DropdownActionBarProps> = ({ type, onClick, label, leftIcon, rightIcon, value, href }) => {
  return (
    <DropdownActionBarWrapper type={type}>
      {leftIcon ? <span>{leftIcon}</span> : null}

      {type === 'switch' ? (
        <Switch onLabel={label} value={value} onValueChange={onClick} />
      ) : type === 'link' ? (
        <Link appearance="primary" size="S" to={href}>
          {label}
        </Link>
      ) : type === 'button' ? (
        <Button variant="primary" size="S" onClick={onClick}>
          {label}
        </Button>
      ) : type === 'textButton' ? (
        <Button variant="text" size="S" onClick={onClick}>
          {label}
        </Button>
      ) : null}

      {rightIcon ? <span>{rightIcon}</span> : null}
    </DropdownActionBarWrapper>
  );
};

export default DropdownActionBar;
